import { render, staticRenderFns } from "./HomeIndex.vue?vue&type=template&id=bd353adc&scoped=true"
import script from "./HomeIndex.vue?vue&type=script&lang=js"
export * from "./HomeIndex.vue?vue&type=script&lang=js"
import style0 from "./HomeIndex.vue?vue&type=style&index=0&id=bd353adc&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd353adc",
  null
  
)

export default component.exports